/*
 * @Author: 陈梦男
 * @Date: 2024-05-22 14:44:21
 * @LastEditTime: 2024-05-24 15:40:41
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @Description: 报告数据管理表头配置
 * @FilePath: \web\src\components\ReportComponents\DataManager\tableConfig.js
 */
const tableConfig = [
  {
    title: '序号',
    slots: { customRender: 'serial' },
    ellipsis: true,
    width: 60,
    align: 'center',
  },
  {
    title: '报告名称',
    dataIndex: 'name',
    slots: {
      customRender: 'name',
    },
    ellipsis: true,
    align: 'center',
    width: 200,
  },
  {
    title: '作者/机构',
    dataIndex: 'owner',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '文件',
    dataIndex: 'fileName',
    ellipsis: true,
    align: 'center',
    // width: 100,
  },
  {
    title: '报告日期',
    dataIndex: 'reportDate',
    ellipsis: true,
    align: 'center',
    // width: 200,
  },

  {
    title: '操作',
    key: 'action',
    dataIndex: 'action',
    slots: { customRender: 'action' },
    align: 'center',
    width: 180,
  },
];
const tableConfigKz = [
  {
    title: '序号',
    slots: { customRender: 'serial' },
    ellipsis: true,
    width: 60,
    align: 'center',
  },
  {
    title: '矿种',
    dataIndex: 'minerals',
    slots: {
      customRender: 'minerals',
    },
    ellipsis: true,
    align: 'center',
  },
  {
    title: '报告名称',
    dataIndex: 'name',
    slots: {
      customRender: 'name',
    },
    ellipsis: true,
    align: 'center',
    width: 200,
  },
  {
    title: '作者/机构',
    dataIndex: 'owner',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '文件',
    dataIndex: 'fileName',
    ellipsis: true,
    align: 'center',
    // width: 100,
  },
  {
    title: '报告日期',
    dataIndex: 'reportDate',
    ellipsis: true,
    align: 'center',
    // width: 200,
  },

  {
    title: '操作',
    key: 'action',
    dataIndex: 'action',
    slots: { customRender: 'action' },
    align: 'center',
    width: 180,
  },
];
const tableConfigGb = [
  {
    title: '序号',
    slots: { customRender: 'serial' },
    ellipsis: true,
    width: 60,
    align: 'center',
  },
  {
    title: '国家',
    dataIndex: 'country',
    slots: {
      customRender: 'country',
    },
    ellipsis: true,
    align: 'center',
  },
  {
    title: '报告名称',
    dataIndex: 'name',
    slots: {
      customRender: 'name',
    },
    ellipsis: true,
    align: 'center',
    width: 200,
  },
  {
    title: '作者/机构',
    dataIndex: 'owner',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '文件',
    dataIndex: 'fileName',
    ellipsis: true,
    align: 'center',
    // width: 100,
  },
  {
    title: '报告日期',
    dataIndex: 'reportDate',
    ellipsis: true,
    align: 'center',
    // width: 200,
  },

  {
    title: '操作',
    key: 'action',
    dataIndex: 'action',
    slots: { customRender: 'action' },
    align: 'center',
    width: 180,
  },
];

export { tableConfig, tableConfigKz, tableConfigGb };
